import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
  selector: 'cbc-container',
  standalone: true,
  imports: [CommonModule, MatProgressSpinner],
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent {
  isLoading = input<boolean>(true);
  showContainer = input<boolean>(true);
  title = input<string>('');
  description = input<string>();
}